import React, { useRef, useState } from 'react';
import ConfirmationDialog from '../../views/ConfirmationDialog';
import ToastStore from '../../stores/ToastStore';

export default function QuestionDeleteConfirmation({ question, onClose, onDelete, onDeleted }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const pending = useRef(false);

  const handleConfirm = async () => {
    if (!question || pending.current) return;
    pending.current = true;
    setIsSubmitting(true);
    setErrorMessage('');
    try {
      await onDelete(question.id);
    } catch (error) {
      setErrorMessage(String(error?.response?.data?.error || error?.response?.data?.message || 'Failed to delete question'));
      return;
    } finally {
      pending.current = false;
      setIsSubmitting(false);
    }
    onClose();
    ToastStore.showToast('Question deleted successfully', 'success');
    try {
      await onDeleted();
    } catch (error) {
      ToastStore.showToast('Question deleted. Reload the page to see the latest list.', 'warning');
    }
  };

  return <ConfirmationDialog
    isOpen={!!question}
    onClose={() => { if (!pending.current) onClose(); }}
    onConfirm={handleConfirm}
    title="Delete Question"
    message="Are you sure you want to delete "
    itemName={question?.question || 'this question'}
    confirmText="Delete"
    confirmIntent="danger"
    isSubmitting={isSubmitting}
    submittingText="Deleting..."
    errorMessage={errorMessage}
    loadingIndicator={<img src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif" width={35} height={35} alt="Deleting..." role="status" />}
  />;
}
